import React, { forwardRef } from 'react';

const SwiperActions = forwardRef(({ prevRef, nextRef, pagination }, ref) => (React.createElement("div", { className: "swiper-actions swiper-buttons" },
    React.createElement("button", { className: "swiper-button swiper-button-prev", type: "button", "aria-label": "Button prev", ref: prevRef },
        React.createElement("span", { className: "icon icon-arrow" })),
    pagination && React.createElement("div", { className: "carousel-pages", ref: ref }),
    React.createElement("button", { className: "swiper-button swiper-button-next", type: "button", "aria-label": "Button next", ref: nextRef },
        React.createElement("span", { className: "icon icon-arrow" })))));
SwiperActions.displayName = 'SwiperActions';

export { SwiperActions as S };
//# sourceMappingURL=SwiperActions-zQ1VhslW.js.map
